// Canvas 画布操作相关的提示信息
export default {
  deleteNodeFailed: "删除失败，请刷新页面重新操作！",
  operationFailed: "操作失败，请刷新页面重新操作！",
  nodeRepeatWarning: "此节点在画布中重复出现{count}次!",
  noMoreNodes: "已无更多节点！",
  doubleClickViewTransaction: "双击查看交易详情",
  addressOwnership: "这是地址归属",
};
